import React from 'react';
import { engineers } from '../mock';
import { Award, Instagram } from 'lucide-react';

const Engineers = () => {
  return (
    <section id="engineers" className="py-20 bg-black">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Meet Our <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">Engineers</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Expert sound engineers with diverse specialties to bring your vision to life
          </p>
        </div>

        {/* Engineers Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {engineers.filter(e => e.active !== false).map((engineer) => (
            <div
              key={engineer.id}
              className="group relative bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-xl overflow-hidden hover:border-purple-500/50 transition-all hover:scale-105"
            >
              {/* Content */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-bold text-white">{engineer.name}</h3>
                  {engineer.premium && (
                    <span className="text-xs bg-gradient-to-r from-purple-600 to-blue-600 text-white px-2 py-1 rounded-full font-medium">
                      Premium
                    </span>
                  )}
                </div>
                <div className="flex items-center space-x-2 mb-3">
                  <Award size={16} className="text-purple-400" />
                  <span className="text-purple-400 text-sm font-medium">{engineer.specialty}</span>
                </div>
                <p className="text-gray-400 text-sm mb-4">{engineer.bio}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="text-xs text-gray-500">
                      <span className="font-semibold">{engineer.experience}</span>
                    </div>
                    {engineer.instagram && (
                      <a
                        href={engineer.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-purple-400 hover:text-purple-300 transition-colors"
                        aria-label={`${engineer.name} Instagram`}
                      >
                        <Instagram size={16} />
                      </a>
                    )}
                  </div>
                  <div className="text-purple-400 font-semibold text-sm">
                    {engineer.rate}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Engineers;